module.exports = __webpack_public_path__ + "fa-solid-900.b9625119ce4300f0ef89.ttf";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf
// module chunks = 2